import { render } from "./KlaviyoLogoIcon.vue?vue&type=template&id=d56ff5c2"
import script from "./KlaviyoLogoIcon.vue?vue&type=script&lang=js"
export * from "./KlaviyoLogoIcon.vue?vue&type=script&lang=js"

import "./KlaviyoLogoIcon.vue?vue&type=style&index=0&id=d56ff5c2&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__